export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  imageUrl: string;
  features: string[];
  applications: string[];
}

export const categories: Category[] = [
  {
    slug: 'industrial-heavy-duty',
    name: '工业级重型插接件',
    description: '专为严苛工业环境设计，承受高负荷、高频率插拔操作。采用高强度合金材料与精密加工工艺，确保在极端温度、振动和腐蚀环境下依然保持稳定可靠的连接性能。久久插工业级重型系列，是重工业领域持久稳固连接的标杆选择。',
    icon: 'ri-building-4-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Heavy%20duty%20industrial%20electrical%20connector%20on%20clean%20light%20workshop%20background%2C%20metallic%20finish%2C%20minimal%20industrial%20design%2C%20soft%20studio%20lighting%2C%20professional%20product%20photography%2C%20warm%20neutral%20tones%2C%20high%20quality&width=800&height=520&seq=cat-industrial-heavy&orientation=landscape',
    features: [
      '高强度合金外壳，抗冲击耐磨损',
      'IP68 防护等级，防水防尘防腐蚀',
      '耐温范围 -40°C 至 +125°C',
      '自锁机构设计，杜绝意外松脱',
      '额定电流最高可达 630A',
      '插拔寿命超过 10,000 次'
    ],
    applications: ['重型机械制造', '矿山开采设备', '船舶与海洋工程', '电力输配系统', '石化炼油装置']
  },
  {
    slug: 'anti-vibration-locking',
    name: '防振自锁插接件',
    description: '久久插防振自锁系列采用专利锁紧机构，在持续振动和冲击环境下自动锁止，从根本上解决插接松动问题。无论是高速运转设备还是移动机械平台，防振自锁插接件都能确保连接始终稳固如初。',
    icon: 'ri-lock-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Locking%20mechanism%20industrial%20connector%20with%20metal%20housing%2C%20clean%20light%20background%2C%20precision%20engineering%20design%2C%20soft%20studio%20lighting%2C%20professional%20product%20photography%2C%20warm%20neutral%20tones&width=800&height=520&seq=cat-antivibration&orientation=landscape',
    features: [
      '专利双锁止卡扣结构',
      '抗振等级达到 MIL-STD-810G',
      '即插即锁，单手操作便捷',
      '锁止状态可视化指示',
      '解锁力精确控制在 15N-25N',
      '百万次振动测试零失效'
    ],
    applications: ['轨道交通车辆', '风力发电机组', '工程机械液压系统', '航空航天测试设备', '汽车制造生产线']
  },
  {
    slug: 'high-speed-data',
    name: '高速数据传输插接件',
    description: '针对现代工业4.0和智能制造需求，久久插高速数据系列支持超高速信号传输与电源一体化连接。采用屏蔽隔离设计与阻抗匹配技术，确保数据完整性和传输稳定性，是智能化设备互联的理想选择。',
    icon: 'ri-radar-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=High%20speed%20data%20connector%20with%20gold%20contacts%20on%20clean%20light%20surface%2C%20precision%20electronic%20components%2C%20minimal%20tech%20design%2C%20soft%20studio%20lighting%2C%20professional%20product%20photography&width=800&height=520&seq=cat-highspeed-data&orientation=landscape',
    features: [
      '支持 10Gbps 以上数据传输速率',
      '360° 全屏蔽抗干扰设计',
      '电源与信号混合一体化接口',
      '兼容 EtherCAT、PROFINET 等工业协议',
      '金触点镀层，接触电阻 < 5mΩ',
      '紧凑型设计节省安装空间'
    ],
    applications: ['工业机器人', '智能传感器网络', '自动化控制系统', '数据中心配电', '医疗影像设备']
  },
  {
    slug: 'waterproof-outdoor',
    name: '防水户外插接件',
    description: '久久插防水户外系列专为户外和潮湿环境打造，采用多重密封技术与耐候材料，确保在雨水浸泡、高湿度、紫外线暴晒等恶劣条件下依然保持可靠的电气连接。从户外照明到通信基站，防水户外系列守护每一次连接。',
    icon: 'ri-drop-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Waterproof%20sealed%20industrial%20connector%20with%20rubber%20gasket%2C%20clean%20light%20background%2C%20durable%20outdoor%20grade%20design%2C%20soft%20studio%20lighting%2C%20professional%20product%20photography%2C%20warm%20neutral%20tones&width=800&height=520&seq=cat-waterproof&orientation=landscape',
    features: [
      'IP69K 最高防护等级',
      '三重密封圈结构设计',
      '抗紫外线老化材料',
      '宽温域 -55°C 至 +150°C',
      '盐雾测试超过 2000 小时',
      '符合 UL 94 V-0 阻燃标准'
    ],
    applications: ['户外 LED 照明系统', '5G 通信基站', '光伏发电阵列', '港口码头设备', '农业灌溉自动化']
  },
  {
    slug: 'miniature-precision',
    name: '微型精密插接件',
    description: '在有限空间内实现可靠连接是久久插微型精密系列的核心使命。采用微米级加工精度和弹性触点设计，在极小体积内提供稳定的电气和机械连接。广泛应用于医疗、航空航天等对空间和可靠性有极致要求的领域。',
    icon: 'ri-contrast-2-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Miniature%20precision%20electronic%20connector%20on%20clean%20light%20surface%2C%20tiny%20gold%20pins%2C%20micro%20engineering%2C%20minimal%20tech%20design%2C%20soft%20studio%20lighting%2C%20professional%20macro%20photography&width=800&height=520&seq=cat-miniature&orientation=landscape',
    features: [
      '最小间距可达 0.5mm',
      '弹性镀金触点，插拔柔和',
      '低插入力高保持力设计',
      '重量轻至 0.3g',
      '接触可靠性 > 99.999%',
      '符合航空航天 AS9100 标准'
    ],
    applications: ['植入式医疗器械', '航空航天航电系统', '精密测量仪器', '微型无人机', '可穿戴智能设备']
  },
  {
    slug: 'modular-custom',
    name: '模块化定制插接方案',
    description: '久久插模块化定制系列提供灵活的组合式插接解决方案，支持按需配置电源、信号、气动、光纤等多种连接模块。高度可定制的设计理念，让客户能够针对特定应用场景打造专属的插接系统。',
    icon: 'ri-puzzle-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modular%20connector%20system%20with%20interchangeable%20parts%20on%20clean%20light%20background%2C%20flexible%20configuration%20design%2C%20industrial%20aesthetic%2C%20soft%20studio%20lighting%2C%20professional%20product%20photography&width=800&height=520&seq=cat-modular&orientation=landscape',
    features: [
      '电源/信号/气动/光纤混合配置',
      '标准接口模块即插即用',
      '支持 2 至 24 芯自由组合',
      '快速定制交期 7-15 个工作日',
      '模块热插拔设计',
      '统一安装尺寸，互换性强'
    ],
    applications: ['半导体制造设备', '自动化测试系统', '舞台灯光音响', '轨道交通信号系统', '实验室精密设备']
  }
];